import SuggestionCard from "components/searchPage/suggestionsComponents/SuggestionCard";
import React, { useContext, useEffect, useState } from "react";
import { CurrentUserContext } from "App";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function MainSuggestionsComponent() {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const [suggestionsElements, setSuggestionsElements] = useState(null);

  // sync with server
  useEffect(() => {
    fetch(`${API_URL}/getRandomSuggestedUsers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === "success") {
          const resultingElements = r.suggestedUsers.map((suggestedUser) => {
            return (
              <SuggestionCard
                key={suggestedUser.id}
                user_id={suggestedUser.id}
                avatar={suggestedUser.avatar && suggestedUser.avatar !== "sampleAvatar.png"
                  ? suggestedUser.avatar
                  : undefined}
                username={suggestedUser.username}
              />
            );
          });
          setSuggestionsElements(resultingElements);
        }
      });
  }, [currentUser.token]);

  return (
    <aside className="d-flex flex-column align-items-center justify-content-evenly rounded gap-2">
      {/* TITLE */}
      <h2 style={{ fontSize: "1.6rem", color: "var(--main-purple)" }}>
        Suggestions
      </h2>

      {/* TOP THREE SUGGESTIONS*/}
      <div
        className="d-flex flex-column align-items-center justify-content-between gap-5"
        style={{ maxWidth: "10rem" }}
      >
        {suggestionsElements || "no"}
      </div>
    </aside>
  );
}
